export default "__VITE_PUBLIC_ASSET__47c28388__"